import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="nvf-footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/nvf-logo.png" alt="NVF Logo" className="footer-logo-image" />
              <div className="footer-logo-text-wrapper">
                <span className="footer-logo-text">Naturellement Vert</span>
                <span className="footer-logo-tagline">LA FERTILISATION REPENSÉE</span>
              </div>
            </div>
            <p className="footer-description">
              Votre expert en fertilisation naturelle et entretien de pelouse en Estrie.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/services">Nos Services</Link></li>
              <li><Link to="/galerie">Réalisations</Link></li>
              <li><Link to="/avis">Avis</Link></li>
              <li><Link to="/a-propos">À propos</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links">
              <li><Link to="/services">Fertilisation naturelle</Link></li>
              <li><Link to="/services">Contrôle des mauvaises herbes</Link></li>
              <li><Link to="/services">Taille de haies</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-heading">Contactez-nous</h3>
            <ul className="footer-contact">
              <li>
                <MapPin size={18} />
                <span>Estrie, Québec</span>
              </li>
              <li>
                <Phone size={18} />
                <a href="tel:4502101858">450 210 1858</a>
              </li>
              <li>
                <Mail size={18} />
                <a href="mailto:info@nvfertilisation.com">info@nvfertilisation.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} NVF - Naturellement Vert Fertilisation. Tous droits réservés.
          </p>
          <div className="footer-bottom-links">
            <span className="neq">NEQ : 2280919921</span>
            <span className="separator">|</span>
            <a href="/privacy-policy">Politique de confidentialité</a>
            <span className="separator">|</span>
            <a href="/data-deletion">Demande de suppression de données</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
